const state = () => ({
  accessRulesIsSet: false,
  appIsLoading: false,
  themeIsSetting: false,
})

export default state
